module.exports = {
  production: true,
  api: "https://staging.api.box.waterdog.mobi/v1/backoffice",
  amplify: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_BEEbU5nJ2",
    userPoolWebClientId: "62i17rtkeip3indirte8qdn730",
  },
};
  